import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F1E1D",
      "fill-rule": "evenodd",
      d: "M3.1 4a.9.9 0 0 1 .9-.9h1.83a.9.9 0 0 1 .88.71l.537 2.476h12.684c1.277 0 2.213 1.2 1.903 2.438l-1.431 5.727a3.02 3.02 0 0 1-2.633 2.275l-7.238.724a3.025 3.025 0 0 1-3.26-2.382L5.65 7.415l-.01-.038L5.106 4.9H4a.9.9 0 0 1-.9-.9m4.533 4.086 1.4 6.609c.129.61.697 1.026 1.32.964l7.238-.724c.514-.051.94-.42 1.065-.921l1.432-5.726a.162.162 0 0 0-.157-.202zM8.234 20.602a1.29 1.29 0 1 1 2.574.001 1.29 1.29 0 0 1-2.574 0m1.8-.001v.002zM17.165 20.602a1.29 1.29 0 1 1 2.574.001 1.29 1.29 0 0 1-2.574 0m1.8-.001v.002z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }